import classnames from 'classnames'
import { PureComponent } from 'preact-compat'

interface ContentProps {
  content: string
  className?: string
  isControl?: boolean
}

class Content extends PureComponent<ContentProps> {
  element: HTMLElement | null = null

  componentDidUpdate(): void {
    this.renderSubComponents()
  }

  componentDidMount(): void {
    this.renderSubComponents()
  }

  renderSubComponents(): void {
    if (this.element) {
      window.insided.bindPreactComponents(this.element)
    }
  }

  render({ content, className, isControl }: ContentProps) {
    return (
      <div
        data-helper='gallery'
        data-data='{"delegate": "img:not([src*=\"emojione\"]), a.fancybox img", "type": "image"}'
        ref={(element) => {
          this.element = element
        }}
        className={classnames(className, 'post__content', 'post__content--new-editor', {
          'post__content--control': isControl
        })}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    )
  }
}

export default Content
